import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { HttpErrorResponse } from '@angular/common/http';
import { MonitoringService } from './monitoring.service';
import { MessageService } from 'primeng/api';
import { ToastMessageConfig } from '@shared/_constants';
import { ConfigService } from '@services/config.service';

@Injectable()
export class LoggingService {
  constructor(private logger: NGXLogger, private monitoringService: MonitoringService, private messageService: MessageService) {}

  public trace(className: string, methodName: string, message: any, ...additional: any[]): void {
    message = this.formatMessage(className, methodName, message);
    this.logger.trace(message, ...additional);
  }

  public debug(className: string, methodName: string, message: any, additional: any[]): void {
    message = this.formatMessage(className, methodName, message);
    this.logger.debug(message, ...additional);
  }

  public info(className: string, methodName: string, message: any, ...additional: any[]): void {
    message = this.formatMessage(className, methodName, message);
    this.logger.info(message, ...additional);
  }

  public log(className: string, methodName: string, message: any, ...additional: any[]): void {
    message = this.formatMessage(className, methodName, message);
    this.logger.log(message, ...additional);
  }

  public warn(className: string, methodName: string, message: any, ...additional: any[]): void {
    message = this.formatMessage(className, methodName, message);
    this.logger.warn(message, ...additional);
  }

  public error(className: string, methodName: string, message: any, ...additional: any[]): void {
    message = this.formatMessage(className, methodName, message);
    this.monitoringService.logErrorMessage(message);
    this.logger.error(message, ...additional);
    this.addErrorToast(className, message);
  }

  public httpError(className: string, methodName: string, error: HttpErrorResponse, ...additional: any[]): void {
    const message = this.formatHttpErrorMessage(className, methodName, error);
    this.monitoringService.logErrorMessage(message);
    this.logger.error(message, ...additional);
    this.addErrorToast(methodName, message);
  }

  private formatMessage(className: string, methodName: string, message: string) {
    return `${className} > ${methodName} > ${message}`;
  }

  private formatHttpErrorMessage(className: string, methodName: string, error: HttpErrorResponse) {
    let message = `${className} > ${methodName} > Error Details:\n ErrorMessage: ${error.message}`;
    switch (error.status) {
      case 0:
        // do nothing else for these
        break;
      default:
        message += `\n Error: ${JSON.stringify(error.error)}`;
        break;
    }

    return message;
  }

  private addErrorToast(summary, message) {
    if (ConfigService.UiErrorNotificationsEnabled) {
      this.messageService.add({
        severity: ToastMessageConfig.SEVERITY_ERROR.toString(),
        summary: summary,
        detail: message,
        life: ToastMessageConfig.AUTO_DISMISS_AFTER_MS,
      });
    }
  }
}
